import { extend } from 'vee-validate';

extend('mustPickOne', {
  validate: async (value) => value !== 0,
  message: 'Musíte zvolit jednu možnost!'
});

export default {};
